import React from "react";

const CalendlyButton = ({ text = "Book Your Free Consultation" }) => {
  return (
    <button
      onClick={() =>
        window.Calendly.initPopupWidget({
          url: "https://calendly.com/info-ebaw/free-initial-consultation"
        })
      }
      className="bg-[#da3e13] hover:bg-[#b9320f] text-white font-semibold py-3 px-6 rounded-full shadow-md transition"
    >
      {text}
    </button>
  );
};

export default CalendlyButton;
